<template>
  <div id="site-report-router-wrapper" class="h-full w-full">
    <SiteReportRouteContainer :siteId="siteId" :isShared="isShared" />
  </div>
</template>

<script>
import { SiteReportRouteContainer } from "react-migration/layouts/SiteReport/SiteReportRouteContainer";

export default {
  data() {
    return { siteId: null, isShared: false, activeAssessmentLayers: null, siteOptions: null };
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search);
    this.siteId = urlParams.get("siteId");
    this.isShared = urlParams.get("isShared") === "true";
  },
  components: {
    SiteReportRouteContainer,
  },
};
</script>

<style scoped>
#site-report-router-wrapper > div {
  height: 100%;
  width: 100%;
}
</style>
